import { a as __extends, b as __awaiter, e as __generator, d as __assign, C as ClientSDKProxyContext, _ as __makeTemplateObject } from '../../chunks/chunk-525a49bc.js';
import { Tabs } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT, a as ERROR_API_UNEXPECTED_RESULTS } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import { C as CanceledPromiseException, c as connectPromiseToUnmountState } from '../../chunks/chunk-6cec2b98.js';
import { d as defaultTheme, w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'lodash';
import 'moment';
import '../../chunks/chunk-06cde6d9.js';
import '../DescriptionList/index.js';
import { AssetDetailsPanel } from '../AssetDetailsPanel/index.js';
import { A as AssetDocumentsPanel } from '../../chunks/chunk-203756f9.js';
import 'ms';
import '../../chunks/chunk-5dec4ccb.js';
import { AssetEventsPanel } from '../AssetEventsPanel/index.js';
import '../TimeseriesChart/index.js';
import '@cognite/griff-react';
import '../../chunks/chunk-65cf8e1d.js';
import 'numeral';
import '../../chunks/chunk-94869f39.js';
import { AssetTimeseriesPanel } from '../AssetTimeseriesPanel/index.js';

var TabPane = Tabs.TabPane;
var AssetMeta = /** @class */ (function (_super) {
    __extends(AssetMeta, _super);
    function AssetMeta(props) {
        var _this = _super.call(this, props) || this;
        _this.isComponentUnmounted = false;
        _this.includesPanel = function (pane) {
            return _this.props.hidePanels ? _this.props.hidePanels.indexOf(pane) < 0 : true;
        };
        _this.handleAssetLoaded = function (asset) {
            _this.setState({
                asset: asset,
                isLoading: false,
            });
        };
        _this.state = {
            assetId: props.assetId,
            asset: null,
            isLoading: true,
        };
        return _this;
    }
    AssetMeta.getDerivedStateFromProps = function (props, state) {
        if (props.assetId !== state.assetId) {
            return {
                isLoading: true,
                asset: null,
                assetId: props.assetId,
            };
        }
        else {
            return null;
        }
    };
    AssetMeta.prototype.componentDidMount = function () {
        // @ts-ignore
        if (!this.includesPanel('details') && this.props.assetId) {
            this.client = this.context(ComponentWithTheme.displayName || '');
            if (!this.client) {
                console.error(ERROR_NO_SDK_CLIENT);
                return;
            }
            this.loadAsset(this.props.assetId);
        }
    };
    AssetMeta.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.assetId !== this.props.assetId &&
            !this.includesPanel('details')) {
            this.loadAsset(this.props.assetId);
        }
    };
    AssetMeta.prototype.componentWillUnmount = function () {
        this.isComponentUnmounted = true;
    };
    AssetMeta.prototype.loadAsset = function (assetId) {
        return __awaiter(this, void 0, void 0, function () {
            var assets, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, connectPromiseToUnmountState(this, this.client.assets.retrieve([{ id: assetId }]))];
                    case 1:
                        assets = _a.sent();
                        if (!assets || assets.length !== 1) {
                            console.error(ERROR_API_UNEXPECTED_RESULTS);
                        }
                        this.handleAssetLoaded(assets[0]);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1 instanceof CanceledPromiseException !== true) {
                            throw error_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AssetMeta.prototype.renderDetails = function () {
        if (!this.includesPanel('details')) {
            return null;
        }
        var _a = this.props, assetId = _a.assetId, styles = _a.styles, customSpinner = _a.customSpinner, detailsProps = _a.detailsProps;
        return (React.createElement(TabPane, { tab: "Details", key: "details", forceRender: true },
            React.createElement(AssetDetailsPanel, __assign({ assetId: assetId, onAssetLoaded: this.handleAssetLoaded, styles: styles && styles.details, customSpinner: customSpinner }, detailsProps))));
    };
    AssetMeta.prototype.renderTimeseries = function () {
        if (!this.includesPanel('timeseries')) {
            return null;
        }
        var _a = this.props, assetId = _a.assetId, timeseriesProps = _a.timeseriesProps, customSpinner = _a.customSpinner, styles = _a.styles;
        return (React.createElement(TabPane, { tab: "Timeseries", key: "timeseries" },
            React.createElement(AssetTimeseriesPanel, __assign({ assetId: assetId }, timeseriesProps, { customSpinner: customSpinner, styles: styles && styles.timeseries }))));
    };
    AssetMeta.prototype.renderDocuments = function () {
        if (!this.includesPanel('documents')) {
            return null;
        }
        var _a = this.props, assetId = _a.assetId, styles = _a.styles, docsProps = _a.docsProps, customSpinner = _a.customSpinner;
        return (React.createElement(TabPane, { tab: "Documents", key: "documents" },
            React.createElement(AssetDocumentsPanel, __assign({}, docsProps, { assetId: assetId, styles: styles && styles.documents, customSpinner: customSpinner }))));
    };
    AssetMeta.prototype.renderEvents = function () {
        if (!this.includesPanel('events')) {
            return null;
        }
        var _a = this.props, assetId = _a.assetId, styles = _a.styles, eventProps = _a.eventProps, customSpinner = _a.customSpinner;
        return (React.createElement(TabPane, { tab: "Events", key: "events" },
            React.createElement(AssetEventsPanel, __assign({}, eventProps, { assetId: assetId, styles: styles && styles.events, customSpinner: customSpinner }))));
    };
    AssetMeta.prototype.render = function () {
        var _a = this.props, assetId = _a.assetId, styles = _a.styles, propsTab = _a.tab, onPaneChange = _a.onPaneChange;
        var _b = this.state, asset = _b.asset, isLoading = _b.isLoading;
        var tab = propsTab === 'documents' || propsTab === 'events' ? propsTab : 'details';
        if (!assetId) {
            return React.createElement("p", null, "no Asset");
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(AssetMetaHeader, { isLoading: isLoading, style: styles && styles.header },
                React.createElement("h3", null, asset ? (asset.name ? asset.name : asset.id) : '...'),
                React.createElement("p", null, (asset && asset.description) || '...')),
            React.createElement(Tabs, { defaultActiveKey: tab, onChange: onPaneChange },
                this.renderDetails(),
                this.renderTimeseries(),
                this.renderDocuments(),
                this.renderEvents())));
    };
    AssetMeta.contextType = ClientSDKProxyContext;
    AssetMeta.defaultProps = {
        theme: __assign({}, defaultTheme),
    };
    return AssetMeta;
}(Component));
var AssetMetaHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ", ";\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? 'hidden' : 'visible');
});
var ComponentWithTheme = withDefaultTheme(AssetMeta);
ComponentWithTheme.displayName = 'AssetMeta';
var templateObject_1;

export { ComponentWithTheme as AssetMeta };
